import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateMaquinaEquipArquivoUseCase } from "../../../presentation/useCases/create/create_maquina_equip_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
export class CreateMaquinaEquipArquivoUseCase implements ICreateMaquinaEquipArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createMaquinaEquipArquivo(
    idMaquinaEquip: number,
    descricao: string,
    arquivo: File | null,
  ): Promise<void> {
    if (arquivo === null) throw new UserFriendlyError("O arquivo é obrigatório!");

    const arquivoNome = arquivo !== null && arquivo !== undefined
      ? await this.getFilename(arquivo)
      : null;


    await this.repository.createControledePatrimonioMaquinaEquipArquivo(
      idMaquinaEquip,
      descricao,
      arquivoNome,
      arquivo,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }
}
